import request from '@/utils/request'
import { BASE_API } from '@/utils/consts'
import _ from 'lodash'

// 埋点请求函数
function rawTrackEvent(data) {
  const params = {
    platform: '云门店',
    // username: localStorage.getItem('nickname'),
    // code: localStorage.getItem('username'),
    clinicName: localStorage.getItem('fulcrum-ancare-clinic-name'),
    functionPage: data.functionPage,
    operateDetail: data.operateDetail,
  }
  // return console.log('埋点请求参数-----', params)
  return request(`${BASE_API}/system/trace/add`, {
    method: 'POST',
    data: params,
  }) 
}

const throttledEventMap = new Map()
function trackEvent(data) {
  const key = `${data.functionPage}_${data.operateDetail}`
  if (!throttledEventMap.has(key)) {
    const throttledFn = _.throttle(rawTrackEvent, 1000, {
      leading: true,
      trailing: false,
    })
    throttledEventMap.set(key, throttledFn)
  }
  throttledEventMap.get(key)(data)
}

// 高阶函数：先执行事件函数 避免服务器压力大的时候事件函数执行失败 导致埋点无效
function withTrack(fn, eventData) {
  return async function (...args) {
    const res = await fn.apply(this, args)
    trackEvent(eventData)
    return res
  }
}

export { trackEvent, withTrack }
